/**
 * 部门模块接口
 */
import { _get, _put, _post } from '@/common/request';
// 获取企业列表
export function getAllCompanyList(params) {
    if (params === void 0) { params = {}; }
    return _get('/property/user/companies', params, true);
}
/**
 * 切换企业
 * https://yapi.lanhanba.com/project/319/interface/api/33788
 */
export function switchCompany(params) {
    return _put('/property/user/change-company', params, true);
}
// 公司名称账号搜索
export function companySearch(params) {
    return _get('/property/companies/search', params, true);
}
// 申请加入公司
export function applyJoinCompany(params) {
    return _put('/property/companies/apply', params, true);
}
// 创建公司
export function creatCompany(params) {
    return _post('/property/companies', params, true);
}
// 创建公司验证手机号、公司名和验证码
export function creatCompanyValid(params) {
    return _put('/property/companies/validate', params, true);
}
// 设置密码
export function setPassword(params) {
    return _put('/property/user/password', params, true);
}
// 设置姓名
export function setName(params) {
    return _put('/property/user/name', params, true);
}
// 发送验证码
export function sendMsg(params) {
    return _put('/property/companies/sms', params, true);
}
// 退出管理公司(1.6 停用)
export function exitManage() {
    return _put('/property/companies/manage/cancel', null, true);
}
